module.exports = __webpack_public_path__ + "img/에스퍼.ec694b79.png";